<template>
    <div>
        <div class="top-banner">
            <div>
                <div  :style="tittlestyle" class="fl tittle">
                    <h2>产品中心-店铺装修</h2>
                    <p>店铺装修像搭积木一样简单，仅需使用鼠标拖拽，即可拥有如同设计师般专业的装修页面</p>
                </div>
                <img  src="/site_static/img/zhuangxiu-logo.png" alt="" class="fr banner-img" :style="banlogostyle">
            </div>
        </div>
        <div style="background: linear-gradient(180deg,#fff,#f1f9f7);padding-bottom: 50px;">
            <div class="video">
                <video id="video" src="/site_static/video/zhuangxiu.mp4" controls></video>
                <div class="play" :style="playcoun">
                    <div style="width: 134px;height: 134px;border-radius: 50%;background: #00c58d;position:absolute;top: 0;bottom: 0;left: 0;right: 0;margin: auto;">
                        <mu-icon size="68" value="play_arrow" color="grey50" style="position:absolute;top: 0;bottom: 0;left: 0;right: 0;margin: auto;" @click="videoplay"></mu-icon>
                    </div>
                </div>
            </div>
            <div class="mtittle" style=" padding: 50px 0 30px 0;">
                <h3>微涟店铺装修的特色</h3>
            </div>
            <div class="decoradion">
                <div>
                    <img src="/site_static/img/deco-sp1.png" alt="">
                    <p class="dtit">易拖拽操作</p>
                    <p>我们将为您提供默认装修样式，首次接触店铺装修也能快速掌握装修技巧</p>
                </div>
                <div>
                    <img src="/site_static/img/deco-sp2.png" alt="">
                    <p class="dtit">装修效率倍增</p>
                    <p>您的装修页面可一键应用，全渠道统一样式更省时，让您的工作效率倍增</p>
                </div>
                <div>
                    <img src="/site_static/img/deco-sp3.png" alt="">
                    <p class="dtit">个性化装修</p>
                    <p>29个装修组件可自由拖拽搭配别具一格，满足您对个性化商城装修的所有幻想</p>
                </div>
            </div>
        </div>
        <div class="mtittle">
            <h3>店铺装修所见即所得，强大的自定义能力，任意拖拽操作即可完成个性化商城装扮</h3>
        </div>
        <div class="zhuangxiu">
            <div>
                <video src="https://ewei.shop/default/img/mp4/gray.mp4" autoplay loop></video>
                <p>后台装修模块演示</p>
            </div>
            <div>
                <video src="https://ewei.shop/default/img/mp4/color.mp4" autoplay loop></video>
                <p>手机端装修展示</p>
            </div>
        </div>
        <div class="mtittle" style="padding: 50px 0 30px 0">
            <h3>优秀设计师装修模板覆盖全行业</h3>
            <p>一键应用精美设计模板，帮助您提升装修效率快速开店</p>
        </div>
        <div class="last">
            <img src="/site_static/img/template1.png" alt="">
            <img src="/site_static/img/template2.png" alt="">
            <img src="/site_static/img/template3.png" alt="">
            <img src="/site_static/img/template4.png" alt="">
        </div>
    </div>
</template>
<script>
    export default {
        name: 'zhuangxiu',
        data(){
            return{
                playcoun:{display:'block'},
                tittlestyle:{},
                banlogostyle:{}
            }
        },
        created: function () {
            let serf = this
            setTimeout(function () {
                serf.tittlestyle={
                    bottom:'125px',
                    opacity: 1}
                serf.banlogostyle={
                    bottom:'45px',
                    opacity: 1}
            },0)

        },
        methods:{
            videoplay(){
               let video = document.getElementById('video')
                console.log(video)
                video.play()
                this.playcoun={display:'none'}
            }
        }
    }
</script>
<style scoped>
    .fl{
        float: left;
    }
    .fr{
        float: right;
    }
    .top-banner{
        background: #49daae;
        color: #fff;
        width: 100%;
        height: 480px;
    }
    .top-banner>div{
        width: 1200px;
        margin: auto;
        height: 100%;
        overflow: hidden;
        position: relative;
    }
    .tittle{
        position: absolute;
        height: 220px;
        transition: all .5s;
        bottom: 0;
        opacity: 0;
    }
    .tittle>h2{
        font-size: 30px;
        margin: 50px 20px 28px 0;
        font-weight: 500;
    }
    .tittle>p{
        font-size: 18px;
        width: 500px;
        line-height: 36px;
        margin-bottom: 30px;
        text-align: left;
    }
    .banner-img{
        position: absolute;
        bottom: 0px;
        opacity: 0;
        transition: all .5s;
    }
    .mtittle>h3{
        font-size: 26px;
        color: #3b426b;
        padding-bottom: 20px;
        font-weight: 500;
    }
    .mtittle>p{
        font-size: 18px;
        color: #5d6494;
    }
    .video{
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 1000px;
        height: 540px;
        margin: 50px auto 0 auto;
        border-radius: 10px;

    }
    .video>video{
        width: 100%;
        height: 100%;
    }
    .play{
        width: 276px;
        height: 276px;
        border-radius: 50%;
        background: rgba(0, 917, 141, .2);
        position: absolute;
    }
    .decoradion{
        background: #fff;
        width: 1000px;
        height: 354px;
        border-radius: 10px;
        justify-content: center;
        padding-top: 72px;
        box-sizing: border-box;
        text-align: center;
        margin: 0 auto;
    }
    .decoradion>div{
        width: 300px;
        float: left;
        margin: 0 15px;
    }
    .decoradion .dtit{
        font-size: 18px;
        font-weight: 500;
        color: #3B426B;
        padding: 20px 0;
    }
    .decoradion p{
        width: 214px;
        margin: 0 auto;
        text-align: center;
        line-height: 26px;
        font-size: 14px;
        color: #5D6494;
    }
    .zhuangxiu video{
        width: 326px;
        margin: 0 40px;
        height: 580px;
        border-radius: 6px;
        box-shadow: 2px 0px 20px #eee;
    }
    .zhuangxiu{
        overflow: hidden;
        width: 820px;
        margin: 0 auto;
    }
    .zhuangxiu p{
        padding-top: 20px;
        color: #7D88A2;
        font-size: 14px;
    }
    .zhuangxiu>div{
        float: left;
    }
    .last>img{
        margin: 0 16px;
        padding-bottom: 50px;
        width: 250px;
        height: 490px;
    }

</style>



// WEBPACK FOOTER //
// src/components/product/zhuangxiu.vue